/** Trạng thái đơn nháp trả về từ API. */
export const ORDER_DRAFT_STATUS = {
  PENDING: 1,
  SUCCESS: 2,
  FAILED: 3,
} as const;

export type OrderDraftStatus = typeof ORDER_DRAFT_STATUS[keyof typeof ORDER_DRAFT_STATUS];

/** Nguồn tạo đơn nháp. */
export const ORDER_DRAFT_SOURCE = {
  CART_MESSENGER: 2,
  SCRIPT_LIVE_STREAM: 3,
  LIVE_STREAM: 4,
  LIVE_SHOPPING_FB: 5,
  CHATBOT_AI: 6,
  LIVESTREAM_COMMENT_PRINTED: 7,
  CART_MARKETING: 8,
} as const;

export type OrderDraftSource = typeof ORDER_DRAFT_SOURCE[keyof typeof ORDER_DRAFT_SOURCE];

/** Loại thông tin sai khiến đơn chưa thể tạo. */
export const ORDER_DRAFT_ERROR_TYPE = {
  ADDRESS: 1,
  PRODUCT: 2,
  MOBILE: 3,
} as const;

export type OrderDraftErrorType = typeof ORDER_DRAFT_ERROR_TYPE[keyof typeof ORDER_DRAFT_ERROR_TYPE];

/** Sản phẩm nhận diện được trong đơn nháp. */
export interface IOrderDraftProduct {
  name?: string | null;
  keyword?: string | null;
  price?: number | null;
  quantity?: number | null;

  [key: string]: unknown;
}

/** Một đơn nháp trong danh sách. */
export interface IOrderDraftItem {
  id: string;
  idNhanh?: string | null;
  orderDraftCode?: string | null;
  conversationId?: string | null;
  postId?: string | null;
  fanpageId?: string | null;
  fanpageUserId?: string | null;
  pageUserId?: string | null;
  fanpageUserName?: string | null;
  phone?: string | null;
  customerMobile?: string | null;
  shippingAddress?: string | Record<string, unknown> | null;
  status?: OrderDraftStatus | null;
  source?: OrderDraftSource | null;
  type?: OrderDraftErrorType | null;
  channel?: string | null;
  message?: string | null;
  products?: IOrderDraftProduct[] | null;
  tagCodes?: string[] | null;
  linkOrderTracking?: string | null;
  dataResponse?: Record<string, unknown> | null;
  createdAt?: number | null;
  customerCreatedAt?: number | null;
}

/** Bộ lọc và cursor gửi lên API danh sách đơn nháp. */
export interface IOrderDraftListParams {
  pageIds: Array<string | number>;
  startTime?: number | null;
  endTime?: number | null;
  id?: string;
  postId?: string;
  conversationId?: string;
  status?: string;
  sourceOrder?: string;
  type?: string;
  tagCodes?: string[];
  orderDraftCode?: string;
  size?: number;
  next?: unknown[];
}

/** Dữ liệu phân trang trả về từ API danh sách đơn nháp. */
export interface IOrderDraftListData {
  result: IOrderDraftItem[];
  next: unknown[];
  totalItems: number;
}

/** Dữ liệu cập nhật trạng thái hoặc nhãn cho một/nhiều đơn nháp. */
export interface IOrderDraftUpdateParams {
  id?: string;
  ids?: string[];
  status?: OrderDraftStatus;
  tagCodes?: string[];
}

/** Kết quả tạo đơn Nhanh tự động từ một đơn nháp. */
export interface IOrderDraftCreateNhanhData {
  trackingUrl: string;
  orderId: string | number;
  calcTotalMoney: number;
}

/** Tham số lấy thông tin hội thoại và khách hàng của đơn nháp. */
export interface IOrderDraftInfoParams {
  conversationId: string;
  customerId: string;
}

/** Thông tin hội thoại cần dùng để mở màn tạo đơn Nhanh. */
export interface IOrderDraftConversationInfo {
  id: string;
  type: number;
  channel: number;
  fanpageId: string;
  fanpageUserId: string;
  fanpageUserName: string;
  status: number;
  updatedTime: number;
  assignedGroupId?: string;
  postIds?: string[];
  adIds?: string[];
  fromAdsId?: number;

  [key: string]: unknown;
}

/** Thông tin khách hàng cần dùng để điền sẵn dữ liệu tạo đơn Nhanh. */
export interface IOrderDraftCustomerInfo {
  id: string;
  name: string;
  phones?: string[];
  email?: string | string[];
  emails?: string[];
  address?: string;
  shippingAddress?: Record<string, unknown>;

  [key: string]: unknown;
}

/** Dữ liệu trả về từ API lấy thông tin theo đơn nháp. */
export interface IOrderDraftInfoData {
  conversation: IOrderDraftConversationInfo;
  customer: IOrderDraftCustomerInfo;
}

/** Dữ liệu link checkout của một đơn nháp. */
export interface IOrderDraftCheckoutData {
  url: string;
}
